export default "__VITE_ASSET__Bs_J_rc$__"